import type { View } from "../../common/types.ts";
import useTitleBar from "../hooks/useTitleBar.tsx";
import { toWorker } from "../util/toWorker.ts";
import { LiveGame } from "./LiveGame/index.tsx";
import { teamsInDisplayOrder } from "../util/boxScoreDisplayOrder.ts";

const ExhibitionGame = ({ liveSim }: View<"exhibitionGame">) => {
	const teamName = (t: (typeof liveSim)["initialBoxScore"]["teams"][number]) =>
		`${t.season} ${t.region} ${t.name}`;
	const [awayTeam, homeTeam] = teamsInDisplayOrder(
		liveSim.initialBoxScore.teams,
	);
	useTitleBar({
		title: "Exhibition Game",
		titleLong: `Exhibition Game » ${teamName(awayTeam)} vs ${teamName(homeTeam)}`,
		hideNewWindow: true,
	});

	return (
		<>
			<p className="mb-1">
				<a href="/exhibition">Sim another exhibition game</a>
			</p>
			<div className="mb-3">
				<button
					className="btn btn-light-bordered btn-sm"
					onClick={async () => {
						const summary = await toWorker(
							"main",
							"generateExhibitionGameSummary",
							liveSim.initialBoxScore,
						);
						if (summary) {
							await navigator.clipboard.writeText(summary);
						}
					}}
					title="Copy game summary to clipboard"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="14"
						height="14"
						fill="currentColor"
						viewBox="0 0 16 16"
					>
						<path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
						<path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
					</svg>
					<span className="ms-1">Copy Game Summary</span>
				</button>
			</div>
			<LiveGame {...liveSim} />
		</>
	);
};

export default ExhibitionGame;
